import HiddenCanvas from '../core/HiddenCanvas';
import { useEffect } from 'react';

const ProfileCanvas = ({
  profileImage,
  imageRatio,
  imageWidth,
  imageHeight,
  onDraw,
  canvasSize,
}) => {
  useEffect(() => {
    if (!profileImage) {
      return;
    }
    const profileImageCanvas = document.getElementById('pCanvas');

    if (profileImage) {
      const profileCtx = profileImageCanvas?.getContext('2d');

      profileCtx?.clearRect(
        0,
        0,
        profileImageCanvas.width,
        profileImageCanvas.height
      );

      profileCtx.save();
      profileCtx.scale(imageRatio, imageRatio);
      profileCtx?.drawImage(profileImage, 0, 0, imageWidth, imageHeight);
      profileCtx.restore();

      onDraw(profileImageCanvas.toDataURL());
    }
  }, [profileImage, imageHeight, imageWidth, imageRatio, onDraw]);

  return <HiddenCanvas id="pCanvas" height={canvasSize} width={canvasSize} />;
};

export default ProfileCanvas;
